// frontend/src/settings/SettingsBackLink.js
// 設定サブページ (/settings/<id>) にいる時だけ「設定一覧へ戻る」を Header 直下に表示する。
// App.js で一度マウントしておけば全ページで有効になる (各ページ側の修正不要)。

import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function SettingsBackLink() {
  const location = useLocation();
  const path = location.pathname || "";

  // /settings/<id> のみ表示 (/settings 自体や、/settings 以外のパスでは出さない)
  if (!path.startsWith("/settings/")) return null;

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: "0 auto",
        padding: "10px 16px 0",
      }}
    >
      <Link
        to="/settings"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          color: "#3b82f6",
          textDecoration: "none",
          fontSize: 13,
          fontWeight: 500,
        }}
      >
        <ArrowLeft size={14} /> 設定一覧へ戻る
      </Link>
    </div>
  );
}
